export default {
  spaces: str => str.replaceAll('_', ' '),
  spacesDash: str => str.replaceAll('-', ' '),
  spacesPlus: str => str.replaceAll('+', ' '),
};
